import { combineReducers } from '@reduxjs/toolkit';
import { popupsSlice } from '@modules/ui/popups';

export { popupsActions, selectPopupState } from './popups';

export const uiReducer = combineReducers({
    popups: popupsSlice.reducer,
});
